import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">

            <div className="footer__top">

                <div className="footer__brand">
                    <p className="footer__tagline">Adopt AI that aligns with your business.</p>

                    <div className="footer__socials">
                        <span className="footer__mark" aria-hidden="true">
                            <img src="/images/star-vector.svg" alt="" />
                        </span>
                        <span className="footer__social-icons">
                            <a className="footer__social" href="https://instagram.com/millionai" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                                <img src="/images/instagram-white.svg" alt="" />
                            </a>
                            <a className="footer__social footer__social--dim" href="https://x.com/millionai" aria-label="X (Twitter)" target="_blank" rel="noopener noreferrer">
                                <img src="/images/twitter-white.svg" alt="" />
                            </a>
                            <a className="footer__social" href="https://linkedin.com/company/millionai" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                                <img src="/images/linkedin-white.svg" alt="" />
                            </a>
                        </span>
                    </div>
                </div>

                <nav className="footer__nav" aria-label="Footer">
                    <div className="footer__col">
                        <h6 className="footer__col-title">Product</h6>
                        <ul className="footer__links">
                            <li><a href="/pages/Maigrid.html">MAIGrid</a></li>
                            <li><a href="/pages/Maigents.html">MAIGent</a></li>
                        </ul>
                    </div>

                    <div className="footer__col">
                        <h6 className="footer__col-title">Resources</h6>
                        <ul className="footer__links">
                            <li><a href="/pages/OurMethodology.html">Our Methodology</a></li>
                        </ul>
                    </div>

                    <div className="footer__col">
                        <h6 className="footer__col-title">Company</h6>
                        <ul className="footer__links">
                            <li><a href="/pages/AboutUs.html">About us</a></li>
                            <li><a href="/contact-us">Contact us</a></li>
                        </ul>
                    </div>
                </nav>
            </div>

            <div className="footer__wordmark" aria-hidden="true">
                <img src="/images/MIAI_half_logo-white.svg" alt="" />
            </div>

            <div className="footer__bottom">
                <p className="footer__copyright">© 2026 million ai. All rights reserved.</p>
                <div className="footer__legal">
                    <a href="/pages/PrivacyNotice.html">Privacy Policy</a>
                    {/* <a href="#">Terms of Use</a> */}
                </div>
            </div>

        </footer>
    );
};

export default Footer;